import Layout from 'components/ui/Layout';
import { useServices } from 'features/service/hooks/useServices';
import { usePrefetchServices } from 'features/service/hooks/usePrefetchServices';
import { useURLSync } from 'features/service/hooks/useURLSync';
import { useToggleServiceStatus } from 'features/service/hooks/useToggleServiceStatus';
import { ViewServiceModal } from 'features/service/components/ViewServiceModal';
import { DeleteConfirmModal } from 'features/service/components/DeleteConfirmModal';
// import { EditServiceModal } from 'features/service/components/';
import { EditServiceModal } from 'features/service/components/EditServiceModal';
import { useMainCategories } from 'features/main-category/hooks/useMainCategories';
import { useUserProfile } from 'features/auth/hooks/useUserProfile';
import { serviceServices }
from 'features/service/services/service.service';
import {
  ChevronLeft,
  ChevronRight,
  Download,
  Edit,
  Eye,
  Plus,
  Search,
  Trash2,
  X,
  Wrench,
  Clock,
  Star,
} from 'lucide-react';
import { useEffect, useState } from 'react';
import { formatDateTime } from 'utils/dateFormatter';
import { useSubCategories } from 'features/sub-category/hooks/useSubCategories';

const ServiceManagement = () => {
  const [filters, setFilters] = useURLSync({
    page: '1',
    limit: '10',
    isActive: 'all',
    approvalStatus: 'all',
    search: '',
    categoryId: '',
    subcategoryId: '',
    sortBy: 'createdAt',
    sortOrder: 'desc',
    
  });

  const [searchInput, setSearchInput] = useState('');
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const { data, isPending, isError, error } = useServices(filters);


  const { data: profileData } = useUserProfile();
const user = profileData?.data;

const restrictedRoles = [
  "delivery_manager",
  "travel_manager",
  "operations_manager",
  "finance_manager",
];

const showPermissionError = restrictedRoles.includes(
  user?.role?.name
);

  // console.log(filters);
  const { prefetchNextPage, prefetchPrevPage } = usePrefetchServices();
  const { mutate: toggleStatus } = useToggleServiceStatus();
  const { data: categoryResponse } = useMainCategories({
  limit: 100,
});

const { data: subCategoryResponse } = useSubCategories({
  parentCategory: filters.categoryId,
  limit: 100,
});

const subCategories = subCategoryResponse?.data || [];

  useEffect(() => {
    if (data?.pagination) {
      const currentPage = data.pagination.page || data.pagination.currentPage;
      const totalPages = data.pagination.totalPages;
      prefetchNextPage({ ...filters, page: String(currentPage) }, totalPages);
      if (currentPage > 1) {
        prefetchPrevPage({ ...filters, page: String(currentPage) });
      }
    }
  }, [data, filters]);

  // console.log('Service listing data:::::::::::::::', data);

  const updateFilter = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      page: key === 'page' ? value : '1',
    }));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchInput !== filters.search) {
        updateFilter('search', searchInput);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchInput]);



  // useEffect(() => {
  //   setSearchInput(filters.search);
  // }, [filters.search]);

  useEffect(() => {
  setSearchInput(filters.search);
}, [filters.search]);



  const handleSort = (column) => {
    const newOrder =
      filters.sortBy === column && filters.sortOrder === 'asc' ? 'desc' : 'asc';
    setFilters((prev) => ({
      ...prev,
      sortBy: column,
      sortOrder: newOrder,
    }));
  };

const handleExport = async () => {
  try {
    const response =
      await serviceServices.exportServices({
        categoryId:
          filters.categoryId,

        subcategoryId: filters.subcategoryId,

        approvalStatus:
          filters.approvalStatus,

        isActive:
          filters.isActive,

        search:
          filters.search,

          sortBy: filters.sortBy,

  sortOrder: filters.sortOrder,
      });

    const blob = new Blob(
      [response.data],
      {
        type: 'text/csv',
      }
    );

    const url =
      window.URL.createObjectURL(
        blob
      );

    const link =
      document.createElement('a');

    link.href = url;

    link.download = `services-${Date.now()}.csv`;

    document.body.appendChild(
      link
    );

    link.click();

    document.body.removeChild(
      link
    );

    window.URL.revokeObjectURL(
      url
    );
  } catch (error) {
    console.error(
      'Failed to export services:',
      error
    );
  }
};

  const SortIcon = ({ column }) => {
    if (filters.sortBy !== column)
      return <span className='text-muted-foreground'>↕</span>;
    return filters.sortOrder === 'asc' ? <span>↑</span> : <span>↓</span>;
  };

  const handleEditClick = (service) => {
    setIsEditModalOpen(true);
    setSelectedService(service);
  };

  const handleDeleteClick = (service) => {
    setSelectedService(service);
    setIsDeleteModalOpen(true);
  };

  const handleViewClick = (service) => {
    setSelectedService(service);
    setIsViewModalOpen(true);
  };

  const handleToggleStatus = (serviceId, currentStatus) => {
    toggleStatus({ serviceId, payload: { isActive: !currentStatus } });
  };

  const getStatusColor = (isActive) => {
    return isActive
      ? 'bg-green-500/10 text-green-600 dark:text-green-400'
      : 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
  };

  const getApprovalStatusColor = (status) => {
    const colors = {
      pending: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
      approved: 'bg-green-500/10 text-green-600 dark:text-green-400',
      rejected: 'bg-red-500/10 text-red-600 dark:text-red-400',
    };
    return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
  };

  // Handle new API response structure: { status, message, pagination, data: [] }
  const services = data?.data || [];
  const pagination = data?.pagination;

  const categories = categoryResponse?.data || [];

  // Helper function to extract image URL from malformed API response
  const getImageUrl = (images) => {
    if (!images || images.length === 0) return null;

    const firstImage = images[0];

    // If it's a string with 'url' property, use that
    if (firstImage?.url && typeof firstImage.url === 'string') {
      return firstImage.url;
    }

    // If it's already a plain string, use it
    if (typeof firstImage === 'string') {
      return firstImage;
    }

    // If it's an object with numeric keys (malformed), reconstruct the URL
    if (typeof firstImage === 'object' && firstImage !== null) {
      // Check if it has 'url' property that's an object with numeric keys
      if (firstImage.url && typeof firstImage.url === 'object') {
        const urlChars = Object.values(firstImage.url);
        return urlChars.join('');
      }
      // Check if the image itself is an object with numeric keys
      const chars = Object.keys(firstImage)
        .filter((key) => !isNaN(key))
        .sort((a, b) => Number(a) - Number(b));
      if (chars.length > 0) {
        return chars.map((key) => firstImage[key]).join('');
      }
    }

    return null;
  };

  return (
    <Layout>
      <div className='min-h-screen bg-background text-foreground p-6'>
        <div className='max-w-7xl mx-auto'>
          {/* Header */}
          <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 space-y-4 sm:space-y-0'>
            <div>
              <h3 className='text-lg font-semibold mb-1'>Category Management</h3>
              <p className='text-sm text-muted-foreground'>
                Manage services, pricing and availability
              </p>
            </div>

            <div className='flex space-x-3'>
              {/* <button
                onClick={() => setIsAddModalOpen(true)}
                className='flex items-center space-x-2 px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
              >
                <Plus size={16} />
                <span>Add Service</span>
              </button> */}

             {!showPermissionError && (
  <button
    onClick={handleExport}
    className='flex items-center space-x-2 px-4 py-2 text-sm border border-border rounded-md bg-card text-card-foreground hover:bg-accent transition-colors'
  >
    <Download size={16} />
    <span>Export</span>
  </button>
)}
            </div>
          </div>

          {/* Filters */}
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 mb-6'>
            {/* Search */}
            <div className='relative lg:col-span-2'>
              <Search
                className='absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground'
                size={16}
              />
              <input
                type='text'
                placeholder='Search by service name...'
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className='w-full pl-10 pr-10 py-2 text-sm'
              />
              {searchInput && (
                <button
                  onClick={() => setSearchInput('')}
                  className='absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-foreground'
                >
                  <X size={16} />
                </button>
              )}
            </div>
           {/* Category Filter */}
           {/* certain categoris omitted in the filter temporarily */}
{/* <select
  value={filters.categoryId}
  onChange={(e) => updateFilter('categoryId', e.target.value)}
  className='px-3 py-2 text-sm'
>
  <option value=''>All Categories</option>

  {categories.map((category) => (
    <option
      key={category._id}
      value={category._id}
    >
      {category.name?.english}
    </option>
  ))}
</select> */}

<select
  value={filters.categoryId}
  // onChange={(e) => updateFilter('categoryId', e.target.value)}
  onChange={(e) => {
  updateFilter('categoryId', e.target.value);
  updateFilter('subcategoryId', '');
}}
  className='px-3 py-2 text-sm'
>
  <option value=''>All Categories</option>

  {categories
    .filter(
      (category) =>
        ![
          'find jobs',
          'tour & travel',
          'property & real estate',
          'food & beverages',
        ].includes(category.name?.english?.toLowerCase())
    )
    .map((category) => (
      <option
        key={category._id}
        value={category._id}
      >
        {category.name?.english}
      </option>
    ))}
</select>

{/* sub category filter */}


<select
  value={filters.subcategoryId}
  onChange={(e) =>
    updateFilter('subcategoryId', e.target.value)
  }
  className="px-3 py-2 text-sm"
  disabled={!filters.categoryId}
>
  <option value="">All Sub Categories</option>

  {subCategories.map((subcategory) => (
    <option
      key={subcategory._id}
      value={subcategory._id}
    >
      {subcategory.name?.english}
    </option>
  ))}
</select>



           

            {/* Approval Status Filter */}
            <select
              value={filters.approvalStatus}
              onChange={(e) => updateFilter('approvalStatus', e.target.value)}
              className='px-3 py-2 text-sm'
            >
              <option value='all'>All Approval Status</option>
              <option value='pending'>Pending</option>
              <option value='approved'>Approved</option>
              <option value='rejected'>Rejected</option>
            </select>

            <div className='w-full flex gap-3'>

             {/* Active Status Filter */}
            <select
              value={filters.isActive}
              onChange={(e) => updateFilter('isActive', e.target.value)}
              className='px-3 py-2 text-sm flex-1'
            >
              <option value='all'>All Status</option>
              <option value='true'>Active</option>
              <option value='false'>Inactive</option>
            </select>

            {/* Items per page */}
            <select
              value={filters.limit}
              onChange={(e) => updateFilter('limit', e.target.value)}
              className='px-3 py-2 text-sm flex-1'
            >
              <option value='5'>5 per page</option>
              <option value='10'>10 per page</option>
              <option value='20'>20 per page</option>
              <option value='50'>50 per page</option>
            </select>

            </div>

          </div>

          {/* Table */}
          <div className='bg-card border border-border rounded-lg overflow-hidden'>
            <div className='overflow-x-auto'>
              <table className='w-full'>
                <thead className='bg-muted border-b border-border'>
                  <tr>
                    <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Image
                    </th>
                    <th
                      className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase cursor-pointer hover:text-foreground'
                      onClick={() => handleSort('name')}
                    >
                      <div className='flex items-center space-x-1'>
                        <span>Service Name</span>
                        <SortIcon column='name' />
                      </div>
                    </th>
                    <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Category
                    </th>
                    <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Sub-Category
                    </th>
                    <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Seller
                    </th>
                    <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Pricing
                    </th>
                    {/* <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Duration
                    </th> */}
                    {/* <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Rating
                    </th> */}
                    <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Approval
                    </th>
                    <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Status
                    </th>
                    {/* <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Bookings
                    </th> */}
                    <th
                      className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase cursor-pointer hover:text-foreground'
                      onClick={() => handleSort('createdAt')}
                    >
                      <div className='flex items-center space-x-1'>
                        <span>Created</span>
                        <SortIcon column='createdAt' />
                      </div>
                    </th>
                    <th className='px-4 py-3 text-right text-xs font-medium text-muted-foreground uppercase'>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className='divide-y divide-border'>
                  {showPermissionError ? (
    <tr>
      <td
        colSpan={12}
        className='px-4 py-8 text-center text-destructive'
      >
        Error loading services: You do not have permission to perform this action!
      </td>
    </tr>
  ) : isPending ? (
                    <tr>
                      <td
                        colSpan={12}
                        className='px-4 py-8 text-center text-muted-foreground'
                      >
                        Loading services...
                      </td>
                    </tr>
                  ) : isError ? (
                    <tr>
                      <td
                        colSpan={12}
                        className='px-4 py-8 text-center text-destructive'
                      >
                        Error loading services:{' '}
                        {error?.message || 'Something went wrong'}
                      </td>
                    </tr>
                  ) : services.length === 0 ? (
                    <tr>
                      <td
                        colSpan={12}
                        className='px-4 py-8 text-center text-muted-foreground'
                      >
                        No services found
                      </td>
                    </tr>
                  ) : (
                    services.map((service) => (
                      <tr
                        key={service._id}
                        className='hover:bg-muted/50 transition-colors'
                      >
                        {/* Image Column */}
                        <td className='px-4 py-3'>
                          {(() => {
                            const imageUrl = getImageUrl(service.images);
                            return imageUrl ? (
                              <img
                                src={imageUrl}
                                alt={service.name}
                                className='w-12 h-10 rounded-lg object-cover border border-border'
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.parentElement.innerHTML = `<div class='w-12 h-12 rounded-lg bg-muted flex items-center justify-center'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-muted-foreground"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg></div>`;
                                }}
                              />
                            ) : (
                              <div className='w-12 h-12 rounded-lg bg-muted flex items-center justify-center'>
                                <Wrench
                                  size={20}
                                  className='text-muted-foreground'
                                />
                              </div>
                            );
                          })()}
                        </td>

                        {/* Service Name Column */}
                        <td className='px-4 py-3 text-sm font-medium'>
                          <div className='max-w-xs'>
                            <div className='text-foreground truncate'>
                              {service.name}
                            </div>
                            {service.slug && (
                              <div className='text-xs text-muted-foreground truncate'>
                                {service.slug}
                              </div>
                            )}
                          </div>
                        </td>

                        {/* Category Column */}
                        <td className='px-4 py-3 text-sm'>
                          <div className='max-w-xs truncate'>
                            {service.categoryId?.name?.english ||
                              service.category?.name?.english ||
                              'N/A'}
                          </div>
                        </td>

                        <td className='px-4 py-3 text-sm'>
                           {service.subcategoryId?.name?.english && (
                            <div className='max-w-xs truncate'>
                              {service.subcategoryId.name.english}
                            </div>
                          )}
                        </td>

                        {/* Seller Column */}
                        <td className='px-4 py-3 text-sm'>
                          <div className='max-w-xs truncate'>
                            {service.sellerId?.firstName ||
                            service.sellerId?.lastName
                              ? `${service.sellerId?.firstName || ''} ${service.sellerId?.lastName || ''}`.trim()
                              : service.sellerId?.phoneNumber || 'N/A'}
                          </div>
                        </td>

                        {/* Pricing Column */}
                        <td className='px-4 py-3 text-sm'>
                          <div>
                            <div className='font-medium text-foreground whitespace-nowrap'>
                              {service.pricing?.currency || 'INR'}{' '}
                              {(

                                 service?.serviceCharge ||
                                service.pricing?.discountedPrice ||
                                service.pricing?.basePrice ||
                                0
                              ).toFixed(2)}
                            </div>
                            {service.pricing?.discountedPrice > 0 &&
                              service.pricing?.basePrice >
                                service.pricing?.discountedPrice && (
                                <div className='text-xs text-muted-foreground line-through'>
                                  {service.pricing?.currency || 'INR'}{' '}
                                  {service.pricing?.basePrice?.toFixed(2)}
                                </div>
                              )}

                              {/* commenetd out remove the Fixed batch as mentioned in qa doc*/}
                            {/* <div className='text-xs text-muted-foreground capitalize'>
                              {service.pricing?.type}
                            </div> */}
                          </div>
                        </td>

                        {/* Duration Column */}
                        {/* <td className='px-4 py-3 text-sm'>
                          <div className='flex items-center space-x-1 text-muted-foreground'>
                            <Clock size={14} />
                            <span>
                              {service.duration > 0
                                ? `${service.duration} min`
                                : '-'}
                            </span>
                          </div>
                        </td> */}

                        {/* Rating Column */}
                        {/* <td className='px-4 py-3 text-sm'>
                          <div className='flex items-center space-x-1'>
                            <Star
                              size={14}
                              className='text-yellow-600 dark:text-yellow-400'
                            />
                            <span className='font-medium'>
                              {service.ratings?.averageRating?.toFixed(1) ||
                                '0.0'}
                            </span>
                            <span className='text-xs text-muted-foreground'>
                              ({service.ratings?.totalRatings || 0})
                            </span>
                          </div>
                        </td> */}

                        {/* Approval Status Column */}
                        <td className='px-4 py-3 text-sm'>
                          <span
                            className={`px-2 py-1 text-xs font-medium rounded-full capitalize whitespace-nowrap ${getApprovalStatusColor(
                              service.approvalStatus,
                            )}`}
                          >
                            {service.approvalStatus}
                          </span>
                        </td>

                        {/* Active Status Column - TOGGLE SWITCH */}
                        <td className='px-4 py-3 text-sm'>
                          <label className='relative inline-flex items-center cursor-pointer group'>
                            <input
                              type='checkbox'
                              checked={service.isActive}
                              onChange={() =>
                                handleToggleStatus(
                                  service._id,
                                  service.isActive,
                                )
                              }
                              className='sr-only peer'
                            />
                            <div className="w-11 h-6 bg-gray-200 dark:bg-gray-700 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>
                            <span className='ms-3 text-sm font-medium text-foreground group-hover:text-primary transition-colors whitespace-nowrap'>
                              {service.isActive ? 'Active' : 'Inactive'}
                            </span>
                          </label>
                        </td>

                        {/* Bookings Column */}
                        {/* <td className='px-4 py-3 text-sm text-muted-foreground'>
                          {service.stats?.totalBookings || 0}
                        </td> */}

                        {/* Created Date Column */}
                        <td className='px-4 py-3 text-sm text-muted-foreground'>
                          {formatDateTime(service.createdAt)}
                        </td>

                        {/* Actions Column */}
                        <td className='px-4 py-3 text-sm text-right'>
                          <div className='flex items-center justify-end space-x-2'>
                            <button
                              className='p-1 hover:bg-muted rounded transition-colors'
                              title='View Details'
                              onClick={() => handleViewClick(service)}
                            >
                              <Eye
                                size={16}
                                className='text-muted-foreground hover:text-foreground'
                              />
                            </button>
                            <button
                              className='p-1 hover:bg-muted rounded transition-colors'
                              title='Edit Service'
                              onClick={() => handleEditClick(service)}
                            >
                              <Edit
                                size={16}
                                className='text-muted-foreground hover:text-foreground'
                              />
                            </button>
                          <button
                              onClick={() => handleDeleteClick(service)}
                              className='p-1 hover:bg-uted rounded transition-colors'
                              title='Delete Service'
                            >
                              <Trash2
                                size={16}
                                className='text-muted-foreground hover:text-destructive'
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {!showPermissionError && pagination && pagination.totalPages > 1 && (
              <div className='flex flex-col sm:flex-row items-center justify-between px-4 py-3 border-t border-border space-y-3 sm:space-y-0'>
                <div className='text-sm text-muted-foreground'>
                  Showing{' '}
                  {((pagination.page || pagination.currentPage) - 1) *
                    (pagination.limit || pagination.itemsPerPage) +
                    1}{' '}
                  to{' '}
                  {Math.min(
                    (pagination.page || pagination.currentPage) *
                      (pagination.limit || pagination.itemsPerPage),
                    pagination.total || pagination.totalItems,
                  )}{' '}
                  of {pagination.total || pagination.totalItems} services
                </div>

                <div className='flex items-center space-x-2'>
                  <button
                    onClick={() =>
                      updateFilter(
                        'page',
                        String((pagination.page || pagination.currentPage) - 1),
                      )
                    }
                    disabled={(pagination.page || pagination.currentPage) === 1}
                    className='p-2 border border-border rounded-md bg-card hover:bg-accent disabled:opacity-50 disabled:cursor-not-allowed transition-colors'
                  >
                    <ChevronLeft size={16} />
                  </button>

                  <div className='flex items-center space-x-1'>
                    {[...Array(pagination.totalPages)].map((_, idx) => {
                      const page = idx + 1;
                      const current = pagination.page || pagination.currentPage;

                      if (
                        page === 1 ||
                        page === pagination.totalPages ||
                        (page >= current - 1 && page <= current + 1)
                      ) {
                        return (
                          <button
                            key={page}
                            onClick={() => updateFilter('page', String(page))}
                            className={`min-w-[2rem] px-3 py-1 text-sm rounded-md transition-colors ${
                              page === current
                                ? 'bg-primary text-primary-foreground font-medium'
                                : 'bg-card hover:bg-accent border border-border'
                            }`}
                          >
                            {page}
                          </button>
                        );
                      } else if (page === current - 2 || page === current + 2) {
                        return (
                          <span key={page} className='text-muted-foreground'>
                            ...
                          </span>
                        );
                      }
                      return null;
                    })}
                  </div>

                  <button
                    onClick={() =>
                      updateFilter(
                        'page',
                        String((pagination.page || pagination.currentPage) + 1),
                      )
                    }
                    disabled={
                      (pagination.page || pagination.currentPage) ===
                      pagination.totalPages
                    }
                    className='p-2 border border-border rounded-md bg-card hover:bg-accent disabled:opacity-50 disabled:cursor-not-allowed transition-colors'
                  >
                    <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Modals */}
        {/* <AddServiceModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} /> */}
        <EditServiceModal isEditModalOpen={isEditModalOpen} setIsEditModalOpen={setIsEditModalOpen} service={selectedService} />
        <DeleteConfirmModal
          isDeleteModalOpen={isDeleteModalOpen}
          setIsDeleteModalOpen={setIsDeleteModalOpen}
          service={selectedService}
        />
        <ViewServiceModal
          isViewModalOpen={isViewModalOpen}
          setIsViewModalOpen={setIsViewModalOpen}
          service={selectedService}
        />
      </div>
    </Layout>
  );
};

export default ServiceManagement;
